import { render, staticRenderFns } from "./floor2.vue?vue&type=template&id=d6b489b6&scoped=true"
import script from "./floor2.vue?vue&type=script&lang=js"
export * from "./floor2.vue?vue&type=script&lang=js"
import style0 from "./floor2.vue?vue&type=style&index=0&id=d6b489b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b489b6",
  null
  
)

export default component.exports